import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { useNovexData } from "@/hooks/useNovexData";
import { useLang } from "@/context/LanguageContext";
import { SourceBadge } from "@/components/SourceBadge";

export function TreasuryCurve() {
  const { t } = useLang();
  const { status, data, source } = useNovexData("/novex/treasury-curve");
  const curve = data?.curve || [];
  const hasPrev = curve.some((p) => p.prev != null);

  return (
    <div className="rounded-lg border border-[#222733] bg-[#0E1118] p-4 sm:p-5" data-testid="treasury-curve">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="font-heading text-xs font-bold uppercase tracking-wider text-slate-400">{t("tc.title")}</h3>
          <SourceBadge source={source} />
        </div>
        {data?.as_of && <span className="text-[10px] text-slate-600">{t("c.asOf", { date: data.as_of })}</span>}
      </div>
      {status === "loading" ? (
        <div className="h-56 animate-pulse rounded bg-slate-800/40" />
      ) : !curve.length ? (
        <p className="text-sm text-slate-500">{t("tc.none")}</p>
      ) : (
        <div className="h-56">
          <ResponsiveContainer width="99%" height="100%">
            <LineChart data={curve} margin={{ top: 5, right: 10, bottom: 0, left: -18 }}>
              <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#475569" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 10, fill: "#475569" }} tickFormatter={(v) => `${v}%`} axisLine={false} tickLine={false} width={44} domain={["auto", "auto"]} />
              <Tooltip
                contentStyle={{ background: "#0B0E14", border: "1px solid #222733", borderRadius: 8, fontSize: 12 }}
                formatter={(v, n) => [`${Number(v).toFixed(2)}%`, n === "yield" ? t("tc.today") : t("tc.month1")]}
              />
              <Legend formatter={(v) => (v === "yield" ? t("tc.today") : t("tc.month1"))} wrapperStyle={{ fontSize: 11 }} />
              {hasPrev && <Line type="monotone" dataKey="prev" stroke="#64748B" strokeWidth={1.4} strokeDasharray="4 3" dot={false} isAnimationActive={false} />}
              <Line type="monotone" dataKey="yield" stroke="#38BDF8" strokeWidth={2} dot={{ r: 2 }} isAnimationActive={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
